
import { 
  Table, 
  TableBody, 
  TableHeader, 
  TableHead, 
  TableRow,
  TableCell 
} from "@/components/ui/table";
import { UserRow } from "./user-list/UserRow";
import { EmptyUsersList } from "./user-list/EmptyUsersList";

interface AdminUser {
  id: string;
  email?: string;
  full_name?: string;
  avatar_url?: string;
  created_at?: string;
  roles?: string[];
  login_count?: number;
}

interface AdminUsersListProps {
  users: AdminUser[];
  onUserUpdated: () => void;
}

export const AdminUsersList = ({ users, onUserUpdated }: AdminUsersListProps) => {
  if (!users || users.length === 0) {
    return <EmptyUsersList />;
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>User</TableHead>
            <TableHead>Email</TableHead>
            <TableHead>Roles</TableHead>
            <TableHead>Login Count</TableHead>
            <TableHead>Created</TableHead>
            <TableHead className="w-[120px]">Actions</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {users.map((user) => (
            <UserRow 
              key={user.id}
              user={user} 
              onUserUpdated={onUserUpdated} 
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
